import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import MenuSection from "@/components/MenuSection";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Reservation from "@/components/Reservation";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

const Landing = () => (
  <div
    data-testid="landing-page"
    className="min-h-screen overflow-x-clip bg-[#0A0A0C] text-[#F5F2EB]"
  >
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <About />
      <MenuSection />
      <Gallery />
      <Testimonials />
      <Reservation />
    </main>
    <Footer />
    <CartDrawer />
  </div>
);

export default Landing;
